import { useReactiveVar } from '@apollo/client'
import { Select, MenuItem, Box } from '@mui/material'
import { orderFilterVar, SortDirectionEnum } from 'context'
import { useSegmentInteraction } from 'hooks/analytics/segment'
import { capitalize } from 'lodash-es'

export const OrderFilter = () => {
  const order = useReactiveVar(orderFilterVar)
  const { track } = useSegmentInteraction()
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Select
        sx={{ width: '100%' }}
        color="secondary"
        id="sort-direction"
        size="small"
        value={order}
        onChange={(e) => {
          const nextOrder = e.target.value
          track('Events "order" filter changed', { filterValue: nextOrder })
          orderFilterVar(nextOrder as SortDirectionEnum)
        }}
      >
        {Object.values(SortDirectionEnum).map((value) => (
          <MenuItem key={value} value={value}>
            {capitalize(value)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
